import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';
import { useTheme } from '../context/ThemeContext';

function Select() {
  const { isDark, toggleTheme } = useTheme();

  const bgColor = isDark ? '#0F0F0F' : '#FAF9F6';
  const textColor = isDark ? 'text-white' : 'text-black';
  const textMuted = isDark ? 'text-white/70' : 'text-black/70';
  const textSubtle = isDark ? 'text-white/40' : 'text-black/40';
  const textVerySubtle = isDark ? 'text-white/30' : 'text-black/30';
  const linkHover = isDark ? 'hover:text-white/80' : 'hover:text-black/80';

  return (
    <div className={`min-h-screen ${textColor} transition-colors duration-300`} style={{ fontFamily: '"Noto Sans", -apple-system, sans-serif', backgroundColor: bgColor }}>
      <SEO
        title="Select — Keshav Rao"
        description="In this select, I reflected on the tunes and flow of the Santa Monica shore."
      />
      <div className="max-w-[52ch] mx-auto px-6 py-10">
        <motion.header
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          className="mb-6 flex items-start justify-between"
        >
          <div>
            <Link to="/" className={`${textVerySubtle} ${linkHover} text-xs mb-3 inline-block transition-colors`}>
              ← back
            </Link>
            <h1
              className={`text-3xl tracking-tight leading-none ${textColor}`}
              style={{ fontFamily: '"Playfair Display", Georgia, serif', fontStyle: 'italic', fontWeight: 500 }}
            >
              Select.
            </h1>
            <p className={`${textSubtle} text-xs font-mono mt-1`} style={{ fontFeatureSettings: '"onum" 1' }}>
              4/22/26
            </p>
          </div>
          <button
            onClick={toggleTheme}
            className={`w-5 h-5 rounded-full ${isDark ? 'bg-white/3 hover:bg-white/6' : 'bg-black/3 hover:bg-black/6'} transition-all duration-200 flex items-center justify-center mt-1`}
            aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            <div className={`w-1.5 h-1.5 rounded-full ${isDark ? 'bg-white/30' : 'bg-black/30'}`}></div>
          </button>
        </motion.header>

        <motion.p
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.08 }}
          className={`text-sm leading-[1.6] mb-5 ${textMuted}`}
          style={{ fontFeatureSettings: '"liga" 1, "calt" 1' }}
        >
          In this select, I reflected on the tunes and flow of the Santa Monica shore. Did a long run there. March and April have been two months of high highs and some slow days. Let this playlist take you on that journey.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.16 }}
          className="rounded-lg overflow-hidden"
        >
          <iframe
            title="Spotify playlist"
            src="https://open.spotify.com/embed/playlist/7enKNYneCWsIhyfZbfH9a0?utm_source=generator&theme=0"
            width="100%"
            height="420"
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
            style={{ borderRadius: 10 }}
          />
        </motion.div>
      </div>
    </div>
  );
}

export default Select;
